if (!customElements.get('principle-slider')) {
  class PrincipleSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.principle-slider__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-flex',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);

      if (!this.section) return;

      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      if (!this.sliderWrapper) return;

      this.slides = this.sliderWrapper.querySelectorAll('.swiper-slide');
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.sliderInstance = false;

      if (this.enableSlider && this.slides.length > 1) {
        this.init();

        document.addEventListener('matchMobile', () => {
          this.init();
        });

        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }
    }

    init() {
      this.initSlider();
    }

    initSlider() {
      if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

   const sliderOptions = {
  slidesPerView: 1,
   spaceBetween: 10,
  centeredSlides: false,
  navigation: {
    nextEl: this.section.querySelector(this.selectors.nextEl),
    prevEl: this.section.querySelector(this.selectors.prevEl),
  },
  pagination: false,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 1.1,
       spaceBetween: 0,
    },
  },
};

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);

        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        if (window.FoxTheme.a11y) {
          const focusableElements = window.FoxTheme.a11y.getFocusableElements(this);

          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');

              if (slide && this.sliderInstance.slider) {
                this.sliderInstance.slider.slideTo(
                  this.sliderInstance.slider.slides.indexOf(slide)
                );
              }
            });
          });
        }

        if (this.sliderInstance.slider) {
          this.sliderInstance.slider.on('progress', ({ progress }) => {
            this.updateSliderReach(
              progress === 0 ? 'begin' : progress === 1 ? 'end' : 'progress'
            );
          });
        }
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;

          const index = Number(e.target.dataset.index);

          if (!isNaN(index) && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideTo(index);
          }
        });
      }
    }

    updateSliderReach(position) {
      this.dataset.sliderReach = position;
    }
  }

  customElements.define('principle-slider', PrincipleSlider);
}